import {
  RECEIVE_SETTINGS,
  OPEN_POPUP,
  CLOSE_POPUP,
  UPDATE_MASTER_NICK_NAME,
  UPDATE_MASTER_NICK_NAME_SUCCESS,
  UPDATE_MASTER_NICK_NAME_ERROR,
  RESET_MASTER_NICK_NAME_ERROR,
  POSTPAID_USER_TYPE,
  CONVERGENT_USER_TYPE,
  FTTB_USER_TYPE,
  SUB_CONVERGENT_USER_TYPE,
  FETCH_SEB_DATA,
  UPDATE_PERSONAL_DATA,
} from './constants';

import {
  TOGGLE_INVITE_MODAL,
  UPDATE_INCOMING_INVITE,
  SET_POPUP_LOADING,
  SHOW_INVITATION_STATUS,
} from './containers/IncomingInvitationService/store/constants';

const defaultState = {
  isMasterNickNameUpdating: false,
  masterNickNameUpdatingError: null,
  isPostpaid: false,
  isConvergent: false,
  popup: null,
  incomingInvitation: {
    isOpen: false,
    isLoading: false,
    isShowInviteStatus: false,
  },
};

const app = (state = defaultState, action) => {
  const { type, data, key, error } = action;
  switch (type) {
    case RECEIVE_SETTINGS:
      return {
        ...state,
        settings: data,
        isPostpaid: data.userType.toLowerCase() === POSTPAID_USER_TYPE,
        isConvergent: data.selectedLoginType.toLowerCase() === CONVERGENT_USER_TYPE,
        isFttb: data.selectedLoginType.toLowerCase() === FTTB_USER_TYPE,
        isSubConvergent: data.selectedLoginType.toLowerCase() === SUB_CONVERGENT_USER_TYPE,
        isPorted: data.isPorted,
      };
    case OPEN_POPUP:
      return {
        ...state,
        popup: key,
      };
    case CLOSE_POPUP:
      return {
        ...state,
        popup: null,
      };
    case UPDATE_MASTER_NICK_NAME:
      return {
        ...state,
        isMasterNickNameUpdating: true,
      };

    case FETCH_SEB_DATA:
      return {
        ...state,
        sebData: { ...data },
      };

    case UPDATE_MASTER_NICK_NAME_SUCCESS:
      return {
        ...state,
        isMasterNickNameUpdating: false,
        masterNickNameUpdatingError: null,
        settings: {
          ...state.settings,
          nickname: data,
        },
      };

    case UPDATE_PERSONAL_DATA:
      return {
        ...state,
        settings: {
          ...state.settings,
          personalData: data,
        },
      };

    case UPDATE_MASTER_NICK_NAME_ERROR:
      return {
        ...state,
        isMasterNickNameUpdating: false,
        masterNickNameUpdatingError: error,
      };
    case RESET_MASTER_NICK_NAME_ERROR:
      return {
        ...state,
        masterNickNameUpdatingError: null,
      };
    case UPDATE_INCOMING_INVITE:
      return {
        ...state,
        incomingInvitation: {
          ...state.incomingInvitation,
          ...data,
        },
      };
    case TOGGLE_INVITE_MODAL:
      return {
        ...state,
        incomingInvitation: {
          ...state.incomingInvitation,
          isOpen: data,
        },
      };
    case SET_POPUP_LOADING:
      return {
        ...state,
        incomingInvitation: {
          ...state.incomingInvitation,
          isLoading: data,
        },
      };
    case SHOW_INVITATION_STATUS:
      return {
        ...state,
        incomingInvitation: {
          ...state.incomingInvitation,
          isShowInviteStatus: data,
        },
      }
    default:
      return state;
  }
};

export default app;
